export class SetReferrer {
	static readonly type = "[Referrer] Set Referrer";
	constructor(public payload: string | undefined) {}
}

